/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProjectInputs */

const en_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

const fr_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet`)
};

const de_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt`)
};

const it_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto`)
};

const ru_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект`)
};

const es_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto`)
};

const zh_cn2_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目`)
};

const ja_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト`)
};

const hi_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना`)
};

const pt_pt2_project = /** @type {(inputs: ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto`)
};

/**
* | output |
* | --- |
* | "Project" |
*
* @param {ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project = /** @type {((inputs?: ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project(inputs)
	if (locale === "de") return de_project(inputs)
	if (locale === "it") return it_project(inputs)
	if (locale === "ru") return ru_project(inputs)
	if (locale === "es") return es_project(inputs)
	if (locale === "zh-CN") return zh_cn2_project(inputs)
	if (locale === "ja") return ja_project(inputs)
	if (locale === "hi") return hi_project(inputs)
	if (locale === "pt-PT") return pt_pt2_project(inputs)
	return en_project(inputs)
});